module.exports = __webpack_public_path__ + "img/pg-search.781fc5c6.png";